import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { toggleDialog, stepperGoTo } from 'actions/view'
import Button from 'components/theme/Button'
import IndividualFormResponse from './IndividualFormResponse'

export default withRouter(
  connect(
    state => {
      const username =
        state.auth?.session?.idToken?.payload?.['cognito:username']
      const vr_account_id =
        state.auth?.session?.idToken?.payload?.['custom:vr_account_id']

      return {
        dialogOpen: state.view.dialogs?.individualFormResponse?.open,
        customformID:
          state.view.dialogs?.individualFormResponse?.response?.form_id,
        formsPermissions:
          state.data?.screenpermissions?.[
            `screenpermissions-${username}-${vr_account_id}`
          ]?.permissions?.forms,
        // taskModalOpen: state.campaign.addOrEdit.taskModalOpen,
      }
    },
    dispatch => bindActionCreators({ toggleDialog, stepperGoTo }, dispatch),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {
          borderRadius: 28,
          overflowY: 'hidden',
          // height: '100%',
          [theme.breakpoints.down('sm')]: {
            borderRadius: 0,
            overflowY: 'auto',
          },
        },
        dialogContentRoot: {
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
      }))(
        ({
          fullScreen,
          dialogOpen,
          classes,
          toggleDialog,
          history,
          customformID,
          stepperGoTo,
          formsPermissions,
        }) => (
          <Dialog
            fullWidth
            maxWidth="sm"
            fullScreen={fullScreen}
            open={Boolean(dialogOpen)}
            onClose={() =>
              toggleDialog({
                open: false,
                dialog: 'individualFormResponse',
                options: { response: null, sectionsByID: null },
              })
            }
            aria-labelledby="responsive-dialog-title"
            // disableBackdropClick
            // disableEscapeKeyDown
            PaperProps={{ classes: { rounded: classes.rounded } }}
          >
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
              {formsPermissions !== false ? (
                <IndividualFormResponse />
              ) : (
                <div style={{ fontWeight: 'bold', padding: 20 }}>
                  You don't have access to these form results.
                </div>
              )}
            </DialogContent>
            <DialogActions>
              {formsPermissions !== false && (
                <Button
                  onClick={() => {
                    history.push(`/forms/custom/${customformID}`)
                    stepperGoTo(3, 'form')
                    toggleDialog({
                      open: false,
                      dialog: 'individualFormResponse',
                      options: { response: null, sectionsByID: null },
                    })
                  }}
                  color="primary"
                >
                  View form
                </Button>
              )}
              <Button
                onClick={() => {
                  toggleDialog({
                    open: false,
                    dialog: 'individualFormResponse',
                    options: { response: null, sectionsByID: null },
                  })
                }}
                color="primary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        ),
      ),
    ),
  ),
)
